import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../../app.config';
import moment from 'moment';

@Injectable()
export class LogsService {
  constructor (private http: HttpClient , private api: AppConfig) {

  }

  getLogs(page, perPage, search, sort, direction) {
    return this.http.get(this.api.baseUrl + '/logs/allLogs?page=' + page + '&perPage=' + perPage +
      '&search=' + search + '&sort=' + sort + '&direction=' + direction, this.api.jsonTokenHeaders);
  }

  addLogs(type) {
    let formData = {
      type: type,
      date: moment().format()
    }
    return this.http.post(this.api.baseUrl + '/logs/saveLogs' , formData , this.api.jsonTokenHeaders);
  }
}
